/**
 * Centralized API functions for Brand Logo functionality
 */
import { getData, deleteData, postData, putData } from '../apiClient';

export const getBrandLogos = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/brand-logo/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get Room Facilities with pagination API error:", error);
    return {
      success: false,
      ...error,
    };
  }
};

// create new brand logo
export const createBrandLogo = async ({ data }) => {
  try {
    const result = await postData(`/brand-logo/`, data, { "Content-Type": "multipart/form-data" });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("user add API error:", error.status === 400 ? error.error : error.message);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

// get user data with id
export const getBrandLogoById = async (id) => {
  try {
    const result = await getData(`/brand-logo/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get user data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const updateBrandLogo = async ({ id, data }) => {
  try {
    const result = await putData(`/brand-logo/${id}`, data, { "Content-Type": "multipart/form-data" });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update Brand Logo API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete brand logo by id
export const deleteBrandLogo = async ({ id }) => {
  try {
    const result = await deleteData(`/brand-logo/${id}`);
    return {
      data: {
        message: result.message,
        success: true,
        status: result.status
      }
    };
  } catch (error) {
    console.error('Delete brand logo API error:', error);
    return {
      data: {
        success: false,
        error: error.message,
        status: error.response?.status || 500
      }
    };
  }
};